import React, { useState, useEffect } from "react";
import {
    Box, Typography, Button, TextField, InputAdornment, Divider
} from "@mui/material";
import { useOutletContext, } from "react-router-dom";
import { useSelector } from "react-redux";
import { esignIcons } from "../../components/Esign/icons";
import SignersTable from "../../components/Signers/signersTable";
import Loader from "../../components/Loader";
import { esignToolApi } from "../../services/esignApi";

const Signers = () => {
    const { open } = useOutletContext();
    const [signersTableData, setSignersTableData] = useState([])
    const [currentPage, setCurrentPage] = useState(1);
    const [loader, setLoader] = useState(false);
    const [updateSigner, setUpdateSigner] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [page, setPage] = useState(0);

    const fetchAllSigners = async () => {
        setLoader(true)
        try {
          const response = await esignToolApi.fetchfrequentSigner(searchText, page);
          setLoader(false)
          console.log(response)
          if (response?.status) {
            console.log(response)
            setSignersTableData(response.data);
          }
        } catch (error) {
            setLoader(false)
            console.error("Error fetching data:", error);
            if(error?.response?.data?.detail=="Not found.")
            {
                setSignersTableData([])
            }
        }
    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchAllSigners();
          }, 500);
        
          return () => clearTimeout(delayDebounce); 
    }, [searchText, page]);

    return (
      <Box
        sx={{
          flexGrow: 1,
          p: 3,
          width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
          marginLeft: open ? "240px" : "100px",
          transition: "margin 0.3s ease",
          height: "100vh",
          display: "flex",
          background: "#f9f9f9",
        }}
      >
        <Box
          mt={10}
          style={{
            borderRadius: "12px",
            textAlign: "center",
            background: "#fff",
            width: "100%",
            height: signersTableData.length <= 0 ? "calc(100% - 73px)" : "calc(100% - 127px)",
            marginLeft: open ? "" : "1em",
          }}
        >
            <Box sx={{ display: "flex", alignItems:'center', justifyContent: "space-between", padding: "15px 25px" }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 500, lineHeight: '20px', color: "#1D1D1D", ml: 2, paddingBottom: "2px" }}>
                    Signers
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <TextField
                        placeholder="Search..."
                        variant="outlined"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        sx={{
                        boxSizing: "border-box",
                        borderRadius: "10px",
                        backgroundColor: "#fff",
                        borderColor: "#E8E8E9",
                        borderWidth: "5px",
                        "& .MuiOutlinedInput-root": {
                            borderColor: "#E8E8E9",
                            backgroundColor: "none",
                            "&:hover fieldset": {
                            borderColor: "#E8E8E9",
                            },
                            "&.Mui-focused fieldset": {
                            borderColor: "#E8E8E9",
                            },
                        },
                        }}
                        InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                            {esignIcons.searchIcon}
                            </InputAdornment>
                        ),
                        sx: { 
                            borderRadius: "10px",
                            width: 410,
                            height: 40,
                            fontSize: "16px",
                            fontWeight: "500",
                            "& input::-ms-reveal, & input::-ms-clear": {
                                display: "none",
                            },
                            "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                display: "none",
                                WebkitAppearance: "none",
                                margin: 0,
                            },
                            "& input[type=number]": {
                                MozAppearance: "textfield",
                            },
                        },
                        }}
                    />
                    <Button variant="contained" sx={{ width: '150px', height: 40, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={() => {setPreviewOpen(true); setUpdateSigner(false)}} >
                        +Add Signers
                    </Button>
                </Box>
            </Box>
            <Divider />
            {signersTableData.length <= 0 && (
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", position: "relative", left: "50%", top: "41%", transform: "translate(-50%, -50%)"  }}>
                    <img src={`${process.env.PUBLIC_URL}/images/not_found.png`} alt="Premium" style={{ height: 166 }} />
                    <Typography variant="caption" sx={{ fontSize: "18px", fontWeight: "600", color: "#000000" }}>
                        No Signers Found!
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: "14px", fontWeight: "400", color: "#000000" }}>
                        Add Signers by clicking on Add Signer Button for Use <br /> or Future Uses .
                    </Typography>
                    <Button variant="contained" sx={{ mt: "25px", width: '176px', height: 40, color: "#FFFFFF", background:"#185CB7", textTransform: "none", fontSize: "14px", borderRadius: "12px", border: "none", boxShadow: "none", fontWeight: "500", display: "flex", alignItems:"center", gap:1 }} onClick={() => {setPreviewOpen(true); setUpdateSigner(false)}} >
                        + Add Signers
                    </Button>
                </Box>
            )}
            <SignersTable filteredDocs={signersTableData} fetchAllSigners={fetchAllSigners} setPreviewOpen={setPreviewOpen} previewOpen={previewOpen} updateSigner={updateSigner} setUpdateSigner={setUpdateSigner} page={page} setPage={setPage}/>
            {loader && <Loader />}
            {/* <Premium /> */}
        </Box>
      </Box>
    );
};

export default Signers;
